/* eslint-disable react/require-default-props */
import React from 'react';
import BiddingGuaranteeInsurance from 'components/atoms/bidding_guarantee_insurance';
import { NAO_INFORMADO } from 'components/molecules/bidding_summary_constants';
import useGuaranteeInsurance from 'hooks/useGuaranteeInsurance';

import type { BiddingData } from 'store/modules/bidding_store/types';
import type { GarantiasResumo } from 'store/modules/bidding_summary_store/types';

interface BiddingSummaryGarantiasProps {
  garantias: GarantiasResumo;
  bidding?: BiddingData | null;
}

interface GarantiaCardProps {
  title: string;
  description: string;
  exige: boolean;
}

const GarantiaCard: React.FC<GarantiaCardProps> = ({ title, description, exige }) => (
  <div
    className={`bidding-summary-garantia-card rounded p-3 mb-3 ${
      exige ? 'bidding-summary-garantia-card--exige' : 'bidding-summary-garantia-card--nao-exige'
    }`}
  >
    <div className="font-weight-bold mb-2">{title}</div>
    <p className="small mb-0">{description.trim() ? description : NAO_INFORMADO}</p>
  </div>
);

const BiddingSummaryGarantias: React.FC<BiddingSummaryGarantiasProps> = ({
  garantias,
  bidding,
}) => {
  const exigeProposta = garantias.garantia_proposta === true;
  const exigeContrato = garantias.garantia_contrato === true;
  const exigeAdicional = garantias.garantia_adicional === true;
  const exigeRetomada = garantias.garantia_retomada === true;
  const hasGarantiaProposta = Object.prototype.hasOwnProperty.call(garantias, 'garantia_proposta');
  const hasGarantiaContrato = Object.prototype.hasOwnProperty.call(garantias, 'garantia_contrato');
  const hasGarantiaAdicional = Object.prototype.hasOwnProperty.call(
    garantias,
    'garantia_adicional',
  );
  const hasGarantiaRetomada = Object.prototype.hasOwnProperty.call(garantias, 'garantia_retomada');
  const guaranteeInsurance = useGuaranteeInsurance(bidding);
  const showCotacaoButton = guaranteeInsurance.show && guaranteeInsurance.showQuoteButton;

  return (
    <div className="bidding-summary-garantias">
      {hasGarantiaProposta ? (
        <GarantiaCard
          title={exigeProposta ? 'Exige Garantia de Proposta' : 'Não exige Garantia de Proposta'}
          description={garantias.justificativa_proposta ?? ''}
          exige={exigeProposta}
        />
      ) : null}
      {hasGarantiaContrato ? (
        <GarantiaCard
          title={exigeContrato ? 'Exige Garantia de Contrato' : 'Não exige Garantia de Contrato'}
          description={garantias.justificativa_contrato ?? ''}
          exige={exigeContrato}
        />
      ) : null}
      {hasGarantiaAdicional ? (
        <GarantiaCard
          title={exigeAdicional ? 'Exige Garantia Adicional' : 'Não exige Garantia Adicional'}
          description={garantias.justificativa_adicional ?? ''}
          exige={exigeAdicional}
        />
      ) : null}
      {hasGarantiaRetomada ? (
        <GarantiaCard
          title={exigeRetomada ? 'Exige Garantia de Retomada' : 'Não exige Garantia de Retomada'}
          description={garantias.justificativa_retomada ?? ''}
          exige={exigeRetomada}
        />
      ) : null}
      {showCotacaoButton ? (
        <div className="d-flex justify-content-start mt-1 d-print-none">
          <BiddingGuaranteeInsurance
            buttonOnly
            type={guaranteeInsurance.type}
            biddingId={guaranteeInsurance.biddingId}
            buttonLabel="Fazer minha cotação"
            ariaLabel="Fazer minha cotação no ConlicitaSeg em nova aba"
            trackingSource="Resumo do Edital"
          />
        </div>
      ) : null}
    </div>
  );
};

export default BiddingSummaryGarantias;
